var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewtab = function SvgNewtab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.36V12h1.64v10H2V5.36h10V7H3.64v13.36H17ZM14.5 2H22v7.5h-1.64V4.89l-8.75 8.75-1.25-1.25 8.75-8.75H14.5V2Z",
    fill: "#141414"
  })));
};
export { SvgNewtab as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNyAyMC4zNTk0VjEySDE4LjY0MDZWMjJIMlY1LjM1OTM4SDEyVjdIMy42NDA2MlYyMC4zNTk0SDE3Wk0xNC41IDJIMjJWMi44NTkzOFYzLjY0MDYyVjkuNUgyMC4zNTk0VjQuODkwNjJMMTEuNjA5NCAxMy42NDA2TDEwLjM1OTQgMTIuMzkwNkwxOS4xMDk0IDMuNjQwNjJIMTQuNVYyWiIgZmlsbD0iIzE0MTQxNCIvPgo8L3N2Zz4K";